import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { ReaderCatalogKey } from './reader.i18n.js';
import { READER_CATALOG } from './reader.i18n.js';

export type ReaderMessageId = `reader:${ReaderCatalogKey}`;

const PREFIX_LENGTH = 'reader:'.length;

/** `t()` for the stop-gap `reader:` scope (see `reader.i18n.ts`). */
export function useReaderT(): { t: (id: ReaderMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: ReaderMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as ReaderCatalogKey;
      const raw = READER_CATALOG[locale][key] ?? READER_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
